import React, { useEffect, useState, useRef } from 'react'
import { logSessionInfo } from '../../../../../services/logger'
import RaiseHand from '../../../Components/PreCheckIllustrations/RaiseHand'
import './RetryView.scss'
import { getCopyByGradeband } from '../../../../../services/ThemingService'
import { COPY_STRINGS } from '../../../../../constants/translatedCopy'

const RETRY_BUTTON_DELAY_MS = 20000; // 20 seconds

export default function RetryView(props) {
  const { isFirstVisit, speechProps, retryPatter, handleTroubleshoot, midSessionMicTroubleshoot, onRestartSession } = props

  const copy_strings = getCopyByGradeband(COPY_STRINGS, "student_raise_hand");
  const asrCopy = getCopyByGradeband(COPY_STRINGS, 'student_checks');
  const [showRetryButton, setShowRetryButton] = useState(false);
  const timerRef = useRef(null);
  
  useEffect(() => {


    if (isFirstVisit) {
      // Set timer to show retry button after 20 seconds
      timerRef.current = setTimeout(() => {
        setShowRetryButton(true);
      }, RETRY_BUTTON_DELAY_MS);
    }

    // Cleanup timer on unmount
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }
  }, [])

  useEffect(() => {
    // Don't play speech if we have a teacher test result (we're about to switch views)
    const teacherTestResult = new URLSearchParams(window.location.search).get('teacherTestResult')
    if (teacherTestResult) {
      return
    }
    speechProps.abortSpeech(() => {
      if(retryPatter){
        speechProps.speakWithPromise({ textToSpeak: retryPatter })
      } else {
        speechProps.speakWithPromise({ textToSpeak: asrCopy.teacher_modal_default_retry_patter })
      }
    })
  }, [retryPatter])

  const handleStudentRetry = () => {
    logSessionInfo('teacherTroubleshoot_RETRY_STUDENT_ACTIVITY', {})
    props.handleRetry()
  }

  const handleTeacherTroubleshoot = () => {
    logSessionInfo('teacherTroubleshoot_TEACHER_TROUBLESHOOT_CLICKED', {})
    // Clear the timer and show retry button immediately when teacher troubleshoot is clicked
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setShowRetryButton(true);
    handleTroubleshoot()
  }

  return (
    <div className="retry-view">
      {isFirstVisit && <RaiseHand />}
      {isFirstVisit && <p>{copy_strings.title}</p>}
      {(!isFirstVisit || showRetryButton) && (
        <button 
          className={isFirstVisit ? 'secondary' : ''}
          onClick={midSessionMicTroubleshoot ? onRestartSession : handleStudentRetry}
        >
          Restart Activity
        </button>
      )}
      <button 
        className='teacher-troubleshoot-button' 
        onClick={handleTeacherTroubleshoot}
      >
        {copy_strings.teacher_troubleshoot}
      </button>
    </div>
  )
} 